export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
